import TagManager from "react-gtm-module-nonce";
import { getRuntimeEnv } from "const";

function isGoogleTagManagerActive() {
  return getRuntimeEnv("REACT_APP_ENABLE_GTM") === "true";
}

function initializeGTM() {
  if (isGoogleTagManagerActive()) {
    const tagManagerArgs = {
      gtmId: getRuntimeEnv("REACT_APP_GTM_ID"),
      nonce: window.cspNonce,
    };
    TagManager.initialize(tagManagerArgs);
  }
}

function dataLayer(dataLayer, dataLayerName) {
  if (isGoogleTagManagerActive())
    TagManager.dataLayer({
      dataLayer,
      dataLayerName,
    });
}

const GTM = {
  initializeGTM,
  dataLayer,
};

export default GTM;
